import React, {useEffect, useState} from "react";
import ReactLoading from "react-loading";
import axios from "axios";
import SimpleBar from "simplebar-react";
import {confirmAlert} from "react-confirm-alert";
import Button from "devextreme-react/button";
import excelIcon from "../../assets/images/mgsuite/excel-icon.png";
import FileSaver from "file-saver";
import {useTranslation} from "react-i18next";

const ReservierungsListe = ({filterOptions, searchText, onEdit}) => {
    const { t } = useTranslation();
    const [loaderShow, setLoaderShow] = useState(false);
    const [buchungen, setBuchungen] = useState([]);
    const [buchungenFiltered, setBuchungenFiltered] = useState([]);
    const [lotpreferencesAvailable, setLotpreferencesAvailable] = useState(true);

    const activeRights = JSON.parse(localStorage.getItem("rights"));
    const link = localStorage.getItem('link') + '/api/ReservationService';

    axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
    useEffect(() => {
        loadData(false);
    }, [filterOptions]);

    useEffect(() => {
        filterData();
    }, [searchText]);
    
    const loadData = (doExport) => {
        let selectedDepartment = filterOptions.department;
        let fromFilter = filterOptions.from;
        let tillFilter = filterOptions.till;
        
        if (selectedDepartment == null) {
            return;
        }
        
        setLoaderShow(true);

        const request = {
            departmentId: selectedDepartment?.value ?? '',
            from: fromFilter?.toISOString() ?? '',
            till: tillFilter?.toISOString() ?? '',
        }
        const searchParams = new URLSearchParams(request).toString();
        
        if (doExport === true) {
            const getDataLink = link + '/exportexcel?' + searchParams;
           
            axios.get(getDataLink, { responseType: "blob" }).then((response) => {
                FileSaver.saveAs(response.data, "Reservations.xlsx");
                setLoaderShow(false);
            })
            .catch((error) => {
                console.error("Error while loading Data", error);
                setLoaderShow(false);
            });
        } else {
            const getDataLink = link + '?' + searchParams;
           
            axios.get(getDataLink, {}).then((response) => {
                setBuchungen(response.data.data);
                setLotpreferencesAvailable(response.data.lotPreferenceAvailable);
                filterData(response.data.data);
                setLoaderShow(false);
            })
            .catch((error) => {
                console.error("Error while loading Data", error);
                setLoaderShow(false);
            });
        }
    }

    const filterData = (b) => {
        let _buchungen = b ?? buchungen;
        const searchTextNormalized = searchText.toLowerCase();
        setBuchungenFiltered(_buchungen.filter(b =>
            b.numberPlate.toLowerCase().includes(searchTextNormalized) ||
            b.firstname?.toLowerCase()?.includes(searchTextNormalized) ||
            b.lastname?.toLowerCase()?.includes(searchTextNormalized) ||
            b.company?.toLowerCase()?.includes(searchTextNormalized) ||
            b.eMail?.toLowerCase()?.includes(searchTextNormalized)
        ));
    }

    const deleteEntry = (entry) => {
        confirmAlert({
            message: t("allgemein.bestaetigen"),
            buttons: [
                {
                    label: t("allgemein.ja"),
                    onClick: () =>
                        axios
                            .delete(link + '?id=' + entry.id)
                            .then((response) => {
                                const buchungenWithoutDeleted = buchungen.filter(b => b.id !== entry.id);
                                setBuchungen(buchungenWithoutDeleted);
                                filterData(buchungenWithoutDeleted);
                            })

                            .catch((error) => {
                                console.error("Error while deleting", error);
                            }),
                },
                {
                    label: t("allgemein.nein"),
                },
            ],
        }); 
    }
    
    function getHtmlList() {
        let htmlList = [];

        for (let i = 0; i < buchungenFiltered.length; i++) {
            let buchung = buchungenFiltered[i];

            htmlList.push(
                <tr key={buchung.id}>
                    <td>{buchung.creatorUserName}</td>
                    <td>{buchung.departmentName}</td>
                    <td>{buchung.numberPlate}</td>
                    <td>{new Date(buchung.permissionFrom).toLocaleString()}</td>
                    <td>{new Date(buchung.permissionTill).toLocaleString()}</td>
                    {/*<td>{buchung.reservedLotName}</td>*/}
                    {lotpreferencesAvailable && 
                        <td>{buchung.parkingLotPreference}</td>
                    }
                    <td>{buchung.scenarioName}</td>
                    <td>{buchung.company}</td>
                    <td>{buchung.firstname} {buchung.lastname}</td>
                    {/*<td>{buchung.eMail}</td>*/}
                    <td>
                        {activeRights.find((item) => item.includes("ReservationService.Update")) && (
                            <i
                                className="bx bx-edit bx-sm"
                                id="pop-up-button"
                                title={t("allgemein.Bearbeiten")}
                                onClick={() => onEdit(buchung.id)}
                            />)
                        }

                        {activeRights.find((item) => item.includes("ReservationService.Delete")) && (
                            <i
                                className="bx bx-trash bx-sm"
                                id="pop-up-button"
                                style={{marginLeft: "10px"}}
                                title={t("allgemein.Loeschen")}
                                onClick={() => deleteEntry(buchung)}
                            />)
                        }
                    </td>
                </tr>
            );
        }

        return <tbody>{htmlList}</tbody>;
    }

    let header = t("reservationService.reservationList");
    if (filterOptions.department?.value > 0) {
        header += ` ${t("userDepartments.department")}: ${filterOptions.department.label}`;
    }
    if (filterOptions.from) {
        header += ` ${t("allgemein.von")}: ${filterOptions.from.toLocaleString()}`;
    }
    if (filterOptions.till) {
        header += ` ${t("allgemein.bis")}: ${filterOptions.till.toLocaleString()}`;
    }
    return (
        <SimpleBar style={{ width: "100%", height: "100%" }}>
            <div
                id="settings-page-view-container"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                }}
            >
            <div className="einstellungen-box">
                <div className="box-name">{header}</div>
                <div style={{overflow: "auto"}}>
                    {loaderShow === true && (
                        <div style={{position: "absolute"}}>
                            <ReactLoading
                                type={"bars"}
                                color={"#2a3042"}
                                height={80}
                                width={80}
                                name={"Loading"}
                            />
                        </div>
                    )}

                    <table id="dataTable">
                        <thead>
                        <tr>
                            <th style={{textAlign: "center"}}>{t("reservationService.listHeader.creator")}</th>
                            <th style={{textAlign: "center"}}>{t("reservationService.listHeader.department")}</th>
                            <th style={{textAlign: "center"}}>{t("reservationService.listHeader.numberPlate")}</th>
                            <th style={{textAlign: "center"}}>{t("reservationService.listHeader.from")}</th>
                            <th style={{textAlign: "center"}}>{t("reservationService.listHeader.till")}</th>
                            {/*<th style={{textAlign: "center"}}>{t("reservationService.listHeader.reservedLot")}</th>*/}
                            {lotpreferencesAvailable &&
                                <th style={{textAlign: "center"}}>{t("reservationService.listHeader.lotPreference")}</th>
                            }
                            <th style={{textAlign: "center"}}>{t("reservationService.listHeader.scenario")}</th>
                            <th style={{textAlign: "center"}}>{t("reservationService.listHeader.company")}</th>
                            <th style={{textAlign: "center"}}>{t("reservationService.listHeader.name")}</th>
                            {/*<th style={{textAlign: "center"}}>{t("reservationService.listHeader.email")}</th>*/}
                            <th style={{textAlign: "center"}}>
                                <Button id="exportButton" icon={excelIcon} onClick={(e) => { loadData(true); e.cancel = true; return false; }} />

                                {activeRights.find((item) => item.includes("ReservationService.Create")) && (
                                    <button className="button" id="pop-up-button" style={{height: "35px"}} onClick={() => onEdit()}>
                                        {t("allgemein.neu")}
                                    </button>)
                                }
                            </th>
                        </tr>
                        </thead>
                        {getHtmlList()}
                    </table>
                </div>
            </div>
        </div>
        </SimpleBar>
    );
};

export default ReservierungsListe;
